// extracted by mini-css-extract-plugin
export default {"container":"resetCompanyNotifications_container__oFPXq","companyName":"resetCompanyNotifications_companyName__O8ICB"};